import React, { useEffect, useContext, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Icon_Close from '../../Assets/Icons/Icon_Close.png';
import Icon_Edit from '../../Assets/Icons/Icon_Color_Edit.png';
import { Context_UI } from '../../Contexts/Context_UI';
import { useScheduleManagement } from '../../Contexts/Context_ScheduleManagement';
import { useMapRenderer } from '../../Contexts/Context_MapRenderer';
import UI_Card from '../ERUMAUI/UI_Card';
import UI_ChipGroup from '../ERUMAUI/UI_ChipGroup';
import { useAccounts } from '../../Contexts/Context_Accounts';
import UI_Dropdown from '../ERUMAUI/UI_Dropdown';
import { useTemplating } from '../../Contexts/Context_Templating';
import { useStatus } from '../../Contexts/Context_Status_Global';
import UI_Divider from '../ERUMAUI/UI_Divider';
import UI_Form from '../ERUMAUI/UI_Form';
import UI_Input_Text from '../ERUMAUI/UI_Input_Text';
import UI_Input_Text_Long from '../ERUMAUI/UI_Input_Text_Long';
import UI_Icon from '../ERUMAUI/UI_Icons';
import UI_Button from '../ERUMAUI/UI_Button';
import UI_UpdatingStatus from '../ERUMAUI/UI_UpdatingStatus';
import UI_Horizontal_Tabs from '../ERUMAUI/UI_Horizontal_Tabs';

import Panel_Map_Left from './Panel_Map_Left';
import Panel_Map_Center from './Panel_Map_Center';

export default function Subwindow_Map_Chooseroom({ id, zIndex, isActive }) {
    const UI = useContext(Context_UI);
    const { Account_Fetch_ByID_Basic } = useAccounts();
    const { Map_Information, Map_Information_Type } = useMapRenderer();
    const [Account, Account_Set] = useState({ Name: "", Email: "" });
    const { Template_List } = useTemplating();
    const { Confirmer_Respond, Unsaved_Add, Unsaved_Clear } = useStatus();
    const Navigate = useNavigate();
    const Close = (Type) => {
        setTimeout(function () {
            UI.Subwindows_Close(id);
        }, 500);
    }

    const Confirm = async () => {
        const Cleared = Map_Information_Type === "Room";
        if (Cleared) {
            Confirmer_Respond(true, {
                RoomID: Map_Information._id
            }, true, "Window_Map_ChooseRoom");
        }

    }

    const Cancel = async () => {
        Confirmer_Respond(false, {}, true, "Window_Map_ChooseRoom");
    }


    return (
        <ui-subwindow Type='Subwindow' Fullscreen="Fullscreen" id={id} State='Active' Visibility='Open' {...(!isActive ? { inert: "" } : {})} >
            <ui-subwindow-titlebar>
                <h2 className='Subwindow_TitleBar_Title'>
                    Choose from Interactive Map
                </h2>
                <button className='Subwindow_TitleBar_Control' onClick={Cancel}             >
                    <img className='Subwindow_TitleBar_Control_Icon' src={Icon_Close} draggable='false' loading='lazy' alt='' />
                </button>
            </ui-subwindow-titlebar>
            <ui-subwindow-content>
                <div className='SM_Map'>
                    <div className='SM_Map_Directory'>
                        <Panel_Map_Left />
                    </div>
                    <div className='SM_Map_Main'>
                        <Panel_Map_Center />
                    </div>
                    <div className='SM_Map_Selection'>
                        {Map_Information_Type == "Room" ?
                            <>
                                <div>
                                    <h2 className='General_Title'>
                                        {Map_Information?.Name}
                                    </h2>
                                    <UI_Card Type="Panel_Info" Text="Room code" Figure={Map_Information?.Location?.Code} />
                                </div>
                                {/* <UI_Button
                                    Text="Use this room"
                                    Icon={<UI_Icon Name="Map" />}
                                    Icon_Position="Left"
                                    OnClick={Handle_Use} /> */}
                            </>
                            :
                            <>
                                <p className='General_Paragraph'>
                                    Please select a room to use for your reservation.
                                </p>
                            </>
                        }


                        {/* <h2 className='General_Paragraph'>
                                            {Map_Information.Location?.Code}
                                        </h2> */}
                    </div>

                </div>
            </ui-subwindow-content>
            <ui-subwindow-controls>
                <button className='General_Button Subwindow_Control' Type='Secondary' onClick={Cancel}>
                    Cancel
                </button>
                <button className='General_Button Subwindow_Control' Type='Secondary' State="Positive" onClick={Confirm} Clickability={Map_Information_Type === "Room" ? "Enabled" : "Disabled"}>
                    Use this room
                </button>

            </ui-subwindow-controls>
        </ui-subwindow>
    );
}
